export default __webpack_public_path__ + "static/media/pexels-photo-2526878.9f1d0027.jpeg";